import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import {DbcShareScreenComponent} from './dbc-share-screen.component';
import {BeaconstacModule} from 'kaizen-design-system';
import {SkeletonLoaderModule} from '../skeleton-loader/skeleton-loader.module';
import {BeaconstacMobileDrawerModule} from '../beaconstac-mobile-drawer/beaconstac-mobile-drawer.module';
import {PipesModule} from '../pipes/pipes.module';
import {TooltipDirective} from 'ngx-bootstrap/tooltip';
import {AdvancedQrDownloadModalModule} from '../advanced-qr-download-modal/advanced-qr-download-modal.module';
import {ModalDirective} from 'ngx-bootstrap/modal';



@NgModule({
    declarations: [
        DbcShareScreenComponent,
    ],
    imports: [
        CommonModule,
        FormsModule,
        BeaconstacModule,
        SkeletonLoaderModule,
        BeaconstacMobileDrawerModule,
        PipesModule,
        TooltipDirective,
        AdvancedQrDownloadModalModule,
        ModalDirective,
    ],
    exports: [
        DbcShareScreenComponent
    ],
})

export class DbcShareScreenModule { }
